/**
 * Wasser auf dem Gerät (18.10.2026): je Glas eine Zeile, zurücknehmen löscht
 * weich. Die Summe eines Tages rechnet, wer sie braucht.
 */

import { newId } from '@kraftwerk/shared';
import { db } from './local.js';
import type { KraftwerkDatabase, LocalWaterEntry } from './local.js';
import { stamp, writeRow } from './write.js';

export async function listWater(
  date: string,
  database: KraftwerkDatabase = db,
): Promise<LocalWaterEntry[]> {
  return (await database.water_log.where('date').equals(date).toArray())
    .filter((row) => !row.deletedAt)
    .sort((a, b) => a.drankAt.localeCompare(b.drankAt));
}

export async function addWater(
  date: string,
  ml: number,
  database: KraftwerkDatabase = db,
): Promise<LocalWaterEntry> {
  const now = stamp();
  return writeRow(
    'water_log',
    { id: newId(), updatedAt: now, deletedAt: null, date, ml: Math.round(ml), drankAt: now },
    'upsert',
    database,
  );
}

/** Das zuletzt Eingetragene zurücknehmen — ein Fehltipp kostet einen Tipp. */
export async function undoLastWater(date: string, database: KraftwerkDatabase = db): Promise<void> {
  const last = (await listWater(date, database)).at(-1);
  if (!last) return;
  const now = stamp();
  await writeRow('water_log', { ...last, deletedAt: now, updatedAt: now }, 'delete', database);
}
